var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn btn-secondary btn-lg btn-block",attrs:{"to":_vm.destination}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('span',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.label))]),_c('img',{attrs:{"src":require("../assets/ButtonArrow.svg"),"height":"25","alt":"arrow button"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }